/**
 * Reads the `ai-planner-bifrost-override` query param from the current Jira page
 * URL and forwards it to the planner iframe so a specific planner Bifrost build
 * can be pinned via the URL (e.g. for QA, dogfooding, or pre-release validation).
 *
 * Returns `null` when the param is absent or when running outside the browser
 * (SSR), in which case no override is appended and the planner serves its
 * default build.
 */
import { getLocation } from '@jira/ssr__browser-globals/src/getLocation.tsx';

export const getBifrostOverrideFromLocation = (): string | null => {
	const location = getLocation();
	if (location == null) {
		return null;
	}
	const value = new URLSearchParams(location.search).get('ai-planner-bifrost-override');
	return value != null && value !== '' ? value : null;
};
